import React from 'react';

export const UserList = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2503_45637)">
        <path
          d="M7.97266 13.8379C10.0437 13.8379 11.7227 12.159 11.7227 10.0879C11.7227 8.01682 10.0437 6.33789 7.97266 6.33789C5.90159 6.33789 4.22266 8.01682 4.22266 10.0879C4.22266 12.159 5.90159 13.8379 7.97266 13.8379Z"
          stroke="#D4002A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7227 7.83789H23.7227"
          stroke="#D4002A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.7227 12.3379H23.7227"
          stroke="#D4002A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9727 16.8379H23.7227"
          stroke="#D4002A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.97266 18.3379C2.63828 15.7504 5.17703 13.8379 7.97266 13.8379C10.7683 13.8379 13.307 15.7504 13.9727 18.3379"
          stroke="#D4002A"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_2503_45637">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.472656 0.337891)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
